import { FilterPrimaryUseClassEnum } from '@/bundles/GroupFilters/types';
import { Nullable } from '@/utils/types';

const dictionary: Record<FilterPrimaryUseClassEnum, string> = {
  [FilterPrimaryUseClassEnum.primary]: 'Primary Use',
  [FilterPrimaryUseClassEnum.secondary]: 'Secondary Use',
  [FilterPrimaryUseClassEnum.either]: 'Primary or Secondary Use',
};

export const getDynamicPropertyUseTitle = (useClassValue: Nullable<FilterPrimaryUseClassEnum>): string => {
  if (useClassValue && useClassValue in dictionary) {
    return dictionary[useClassValue];
  }

  return 'Property Use';
};
